import React, { useState, useEffect } from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import axios from 'axios';
import { Reveal } from './motion';
import { API_BASE_URL } from '../utils';
import { ORANGE_DK, TXT, TXT_DIM, card, focusRing } from './theme';

/* Renders an accordion list of { q, a } items. Prefers the admin-managed FAQs
   from the API and falls back to the `items` prop if the fetch is empty/fails,
   so the page always renders. `defaultOpen` opens one by index. */
export default function FaqSection({ items, defaultOpen = 0, note }) {
  const [open, setOpen] = useState(defaultOpen);
  const [remote, setRemote] = useState(null);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API_BASE_URL}/api/faqs`)
      .then((res) => {
        if (active && Array.isArray(res.data?.faqs) && res.data.faqs.length) setRemote(res.data.faqs);
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  const list = remote || items || [];
  return (
    <Box sx={{ maxWidth: 880, mx: 'auto' }}>
      {list.map((f, i) => (
        <Reveal key={f.q} delay={i * 35}>
          <Accordion
            disableGutters
            square
            elevation={0}
            expanded={open === i}
            onChange={() => setOpen(open === i ? -1 : i)}
            sx={{
              ...card,
              mb: 1.5,
              borderRadius: '12px !important',
              overflow: 'hidden',
              '&:before': { display: 'none' },
              '&.Mui-expanded': { borderColor: 'rgba(255,102,0,0.4)', boxShadow: '0 10px 30px rgba(255,102,0,0.08)' },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: ORANGE_DK }} />}
              sx={{
                px: { xs: 2, md: 3 },
                ...focusRing,
                '& .MuiAccordionSummary-content': { my: 1.8 },
              }}
            >
              <Typography sx={{ fontWeight: 700, fontSize: { xs: '0.96rem', md: '1.02rem' }, color: TXT, pr: 1 }}>
                {f.q}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: { xs: 2, md: 3 }, pt: 0, pb: 2.6 }}>
              <Typography sx={{ color: TXT_DIM, fontSize: '0.92rem', lineHeight: 1.7 }}>{f.a}</Typography>
            </AccordionDetails>
          </Accordion>
        </Reveal>
      ))}
      {note && (
        <Typography sx={{ color: TXT_DIM, fontSize: '0.78rem', textAlign: 'center', mt: 3, lineHeight: 1.6 }}>
          {note}
        </Typography>
      )}
    </Box>
  );
}
